import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { ENVIRONMENT_TOKEN } from '../injection.tokens';
import { NavigationHelperService } from './navigation/navigation-helper.service';
import { NavigationService } from './navigation/navigation.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private innerContent = new ReplaySubject<string>(1);
  public innerContent$ = this.innerContent.asObservable();

  public constructor(
    @Inject(ENVIRONMENT_TOKEN) protected environment: any,
    protected navigationService: NavigationService,
    private navigationHelperService: NavigationHelperService
  ) {}

  public performActionForButton(actionButtonIdentifier: string): void {
    const actionButtonMap = this.environment.header.actionButtonList;

    if (actionButtonMap && actionButtonMap[actionButtonIdentifier]) {
      const action = actionButtonMap[actionButtonIdentifier];
      if (action && action['action'] && action['action']['nextRouteFor']) {
        this.navigationService.goTo([this.navigationHelperService.getNextRouteForRoute(action['action']['nextRouteFor'])]);
      }
    }
  }

  public setInnerContent(value: string) {
    this.innerContent.next(value);
  }
}
